<template>
  <section
    id="data-processing"
    class="section data-processing"
  >
    <div class="container">
      <div class="section-title">
        <h2>PCB设计数据处理与知识图谱</h2>
        <p>构建智能PCB设计核心知识引擎，赋能全流程AI决策</p>
      </div>

      <!-- 知识图谱可视化区域 -->
      <div class="knowledge-graph">
        <div class="graph-visual">
          <!-- 使用网格布局替代绝对定位 -->
          <div class="node core-node">
            <i class="fas fa-brain" />
            <span>PCB设计引擎</span>
          </div>

          <div class="node data-node node-1">
            <i class="fas fa-microchip" />
            <span>PCB元件库</span>
            <small>XX+万元件</small>
          </div>

          <div class="node data-node node-2">
            <i class="fas fa-border-style" />
            <span>PCB布局方案库</span>
            <small>X万+方案</small>
          </div>

          <div class="node data-node node-3">
            <i class="fas fa-ruler-combined" />
            <span>PCB设计规则库</span>
            <small>XX万+规则</small>
          </div>

          <div class="node data-node node-4">
            <i class="fas fa-bolt" />
            <span>电气特性库</span>
            <small>EMI/EMC规则</small>
          </div>

          <div class="node data-node node-5">
            <i class="fas fa-thermometer-half" />
            <span>热分析数据</span>
            <small>热分布模型</small>
          </div>

          <div class="node data-node node-6">
            <i class="fas fa-cogs" />
            <span>制造参数库</span>
            <small>工艺标准</small>
          </div>

          <div class="connections">
            <!-- 连接线将通过JS动态生成 -->
          </div>
        </div>

        <div class="graph-info">
          <div class="info-header">
            <div class="info-icon">
              <i class="fas fa-sitemap" />
            </div>
            <div class="info-content">
              <h3>PCB知识图谱</h3>
              <p>多维度关联电子设计知识网络</p>
            </div>
          </div>

          <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-value">
                XX万+
              </div>
              <div class="stat-label">
                PCB元件参数
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-value">
                XX万+
              </div>
              <div class="stat-label">
                布局方案
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-value">
                XX万+
              </div>
              <div class="stat-label">
                设计规则
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-value">
                XX万+
              </div>
              <div class="stat-label">
                电气特性
              </div>
            </div>
          </div>

          <p style="margin-top: 20px; font-size: 0.95rem">
            知识图谱融合了IPC标准、行业规范及专家经验，支持多维度查询与推理
          </p>
        </div>
      </div>

      <!-- 知识提取与建模 
      <div class="knowledge-extraction">
        <div class="extraction-card">
          <h3><i class="fas fa-file-alt"></i> PCB文档解析</h3>
          <p>自动化提取设计文档中的关键信息：</p>
          <ul>
            <li>Gerber文件层解析与元件坐标提取</li>
            <li>BOM清单物料识别与参数提取</li>
            <li>原理图信号路径与连接关系分析</li>
            <li>设计约束规则识别与结构化存储</li>
          </ul>
        </div>

        <div class="extraction-card">
          <h3><i class="fas fa-project-diagram"></i> 实体关系提取</h3>
          <p>深度挖掘电子设计领域知识：</p>
          <ul>
            <li>基于BERT的电子领域实体识别</li>
            <li>多源数据实体对齐与融合</li>
            <li>复杂电路关系提取</li>
            <li>跨文档知识关联</li>
          </ul>
        </div>

        <div class="extraction-card">
          <h3><i class="fas fa-cogs"></i> 知识建模</h3>
          <p>构建面向PCB设计的本体模型：</p>
          <ul>
            <li>电子设计领域本体构建</li>
            <li>多粒度知识表示</li>
            <li>时序关系建模</li>
            <li>跨领域知识融合</li>
          </ul>
        </div>
      </div>
      -->
      <!-- 电子知识图谱构建流程 
      <div class="graph-building">
        <h3>电子知识图谱构建</h3>
        <p>从原始数据到可推理知识网络的完整过程</p>

        <div class="building-steps">
          <div class="building-step">
            <div class="step-number">1</div>
            <h4>数据源整合</h4>
            <p>整合Datasheet、IPC标准、设计文档等多源数据</p>
          </div>

          <div class="building-step">
            <div class="step-number">2</div>
            <h4>知识抽取</h4>
            <p>使用AI技术提取实体、属性及关系</p>
          </div>

          <div class="building-step">
            <div class="step-number">3</div>
            <h4>知识融合</h4>
            <p>实体对齐、冲突解决与知识合并</p>
          </div>

          <div class="building-step">
            <div class="step-number">4</div>
            <h4>知识存储</h4>
            <p>使用图数据库存储结构化知识</p>
          </div>

          <div class="building-step">
            <div class="step-number">5</div>
            <h4>质量评估</h4>
            <p>准确性、一致性、完整性验证</p>
          </div>
        </div>
      </div>
      -->
      <!-- 功能入口 -->
      <div class="feature-actions">
        <div class="action-card">
          <div class="action-icon">
            <i class="fas fa-file-import" />
          </div>
          <h3>PCB数据处理</h3>
          <p>导入和管理Gerber/BOM/原理图数据</p>
          <button class="btn btn-primary">
            <i class="fas fa-sign-in-alt" /> 进入数据处理
          </button>
        </div>

        <div class="action-card">
          <div class="action-icon">
            <i class="fas fa-pcb" />
          </div>
          <h3>PCB知识图谱</h3>
          <p>探索PCB设计知识网络</p>
          <button class="btn btn-primary">
            <i class="fas fa-search" /> 探索PCB图谱
          </button>
        </div>

        <div class="action-card">
          <div class="action-icon">
            <i class="fas fa-network-wired" />
          </div>
          <h3>知识图谱API</h3>
          <p>访问结构化PCB设计知识</p>
          <button class="btn btn-primary">
            <i class="fas fa-code" /> API文档
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.data-processing {
  background: var(--gray-50);
}

.section {
  padding: 100px 0;
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: var(--secondary);
}

.section-title p {
  font-size: 1.2rem;
  color: var(--gray);
  max-width: 700px;
  margin: 0 auto;
}

/* 数据处理流程展示 */
.data-processing-flow {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 60px;
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: var(--card-shadow);
}

.flow-header {
  text-align: center;
  margin-bottom: 30px;
}

.flow-header h3 {
  font-size: 2rem;
  color: var(--primary);
  margin-bottom: 15px;
}

.flow-steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
}

.flow-steps::before {
  content: "";
  position: absolute;
  top: 30px;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--gray-light);
  z-index: 1;
}

.flow-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  position: relative;
  z-index: 2;
}

.step-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: var(--primary);
  border: 3px solid var(--primary);
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(37, 99, 235, 0.2);
  position: relative;
  background-color: white;
  z-index: 3;
}

.step-label {
  text-align: center;
  font-weight: 600;
  color: var(--secondary);
  font-size: 16px;
  margin-bottom: 10px;
}

.step-description {
  text-align: center;
  color: var(--gray);
  font-size: 14px;
}

/* 知识图谱优化 */
.knowledge-graph {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
  align-items: flex-start;
  margin-bottom: 60px;
}

.graph-visual {
  flex: 1;
  min-width: 400px;
  position: relative;
  height: 500px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Ccircle cx='100' cy='100' r='2' fill='%232563eb' fill-opacity='0.05'/%3E%3C/svg%3E");
  border-radius: 16px;
  overflow: hidden;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 20px;
  padding: 30px;
}

.graph-visual::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(37, 99, 235, 0.05) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  z-index: 1;
}

.node {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  transition: all 0.4s ease;
  z-index: 10;
  cursor: pointer;
  text-align: center;
  padding: 15px;
  backdrop-filter: blur(2px);
  background: var(--card-bg);
  border: 1px solid var(--gray-200);
  color: var(--gray-700);
  border-radius: 16px;
}

.node i {
  font-size: 36px;
  margin-bottom: 10px;
}

.core-node {
  grid-column: 2;
  grid-row: 2;
  background: linear-gradient(135deg, var(--gray-500), var(--gray-700));
  animation: pulse 2s infinite;
  color: white;
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(107, 114, 128, 0.4); }
  70% { box-shadow: 0 0 0 20px rgba(107, 114, 128, 0); }
  100% { box-shadow: 0 0 0 0 rgba(107, 114, 128, 0); }
}

.data-node {
  background: rgba(255, 255, 255, 0.9);
  color: var(--accent-500);
  border: 2px solid var(--gray-500);
  z-index: 5;
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.node-1 {
  grid-column: 2;
  grid-row: 1;
}

.node-2 {
  grid-column: 3;
  grid-row: 2;
}

.node-3 {
  grid-column: 2;
  grid-row: 3;
}

.node-4 {
  grid-column: 1;
  grid-row: 2;
}

.node-5 {
  grid-column: 1;
  grid-row: 1;
}

.node-6 {
  grid-column: 3;
  grid-row: 1;
}

.data-node:hover {
  transform: scale(1.05);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
  z-index: 15;
}

.connections {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 500'%3E%3Cpath d='M250,150 C350,100 450,100 550,150' stroke='%236b7280' stroke-width='2' fill='none' stroke-opacity='0.2' stroke-dasharray='10,5'/%3E%3C!-- 其他路径颜色同样修改 --%3E%3C/svg%3E");
  background-size: cover;
  opacity: 0.3;
}

.graph-info {
  flex: 1;
  min-width: 300px;
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: var(--card-shadow);
}

.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.info-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: var(--accent-100);;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-500);
  font-size: 24px;
  margin-right: 15px;
}

.info-content h3 {
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: var(--secondary);
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 25px;
}

.stat-card {
  background: rgba(245, 245, 245, 0.8);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  transition: var(--transition);
  border: 1px solid var(--gray-200);
}

.stat-card:hover {
  background: rgba(107, 114, 128, 0.1);
  transform: translateY(-3px);
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: var(--gray-600); 
  margin-bottom: 5px;
}

.stat-label {
  font-size: 0.9rem;
  color: var(--gray);
}

/* 知识提取建模 */
.knowledge-extraction {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.extraction-card {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: var(--card-shadow);
  transition: var(--transition);
  border-top: 4px solid var(--gray-400);
}

.extraction-card:hover {
  transform: translateY(-5px);
  box-shadow: var(--card-shadow-hover);
}

.extraction-card h3 {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  color: var(--accent-500);
}

.extraction-card h3 i {
  margin-right: 10px;
  color: var(--accent-500);
}

.extraction-card ul {
  padding-left: 20px;
}

.extraction-card li {
  margin-bottom: 12px;
  position: relative;
}

.extraction-card li::before {
  content: "•";
  color: var(--primary);
  font-weight: bold;
  position: absolute;
  left: -15px;
}

/* 图谱构建流程 */
.graph-building {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: var(--card-shadow);
  margin-bottom: 60px;
}

.building-steps {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 30px;
}

.building-step {
  flex: 1;
  min-width: 200px;
  padding: 25px;
  background: rgba(37, 99, 235, 0.03);
  border-radius: 12px;
  border-left: 4px solid var(--gray-400);
}

.step-number {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--accent-500);
  margin-bottom: 15px;
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.1);
  text-align: center;
  line-height: 32px;
}

/* 功能入口样式 */
.feature-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  margin-top: 40px;
  justify-content: center;
}

.action-card {
  flex: 1;
  min-width: 300px;
  background: white;
  border-radius: 16px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
  border: 1px solid rgba(37, 99, 235, 0.1);
}

.action-card:hover {
  transform: translateY(-10px);
  border-color: rgba(37, 99, 235, 0.3);
}

.action-icon {
  width: 80px;
  height: 80px;
  background: var(--accent-100);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  color: var(--accent-500);
  font-size: 32px;
}

.action-card h3 {
  font-size: 1.8rem;
  margin-bottom: 15px;
  color: var(--secondary);
}

.action-card p {
  color: var(--gray);
  margin-bottom: 25px;
  min-height: 60px;
}

.btn {
  padding: 12px 30px;
  font-size: 1.1rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  border: none;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.btn-primary {
  background: var(--gray-600);
  color: white;
  box-shadow: 0 5px 15px rgba(37, 99, 235, 0.3);
}

.btn-primary:hover {
  background: var(--primary-dark);
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.4);
}

/* 响应式设计 */
@media (max-width: 992px) {
  .knowledge-graph {
    flex-direction: column;
  }

  .graph-visual {
    min-width: 100%;
    height: 400px;
  }

  .feature-actions {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .section {
    padding: 60px 0;
  }

  .flow-steps {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }

  .flow-steps::before {
    display: none;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }
}
</style>
